export default __webpack_public_path__ + "static/media/credit-bank.b9ebb872.svg";